// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__h7IDa","question":"Question_question__3xqbX","description":"Question_description__3_Rws"};